import { Outlet } from "react-router-dom";

import { FilterTenantProvider } from "./filter-tenant/filter-tenant.context";
import './tenant.scss';

export function Tenant() {
  return (
    <div id="ShellTenant" className="tenant">
       <FilterTenantProvider>
        <Outlet />
      </FilterTenantProvider>
    </div>
  );
}

export default Tenant;
